import {
  MANUFACTURER_MILEAGE_WARRANTY,
  TIRE_PROTECTION_PACKAGE,
  BIG_O_MILEAGE_WARRANTY
} from 'constant'

export const MANUFACTURERS_LIMITED_WARRANTY = 'Manufacturer\'s Limited Warranty'
export const MANUFACTURER_TOOLTIP_MESSAGE = 'Mileage warranty may vary by tire type/usage; see manufacturer’s warranty.'
export const MILEAGE_WARRANTY_TOOLTIP_MESSAGE = '#VALUE# miles tread depth warranty.'
export const TPP_TOOLTIP_MESSAGE = 'Tire Protection On Us! Big O Brand tire purchase includes our Tire Protection Package, free of charge. Protection includes complimentary rotations and rebalances for the life of the tire, as well as 24-hour Roadside Assistance, available nationwide. Plus, we’ll repair, replace or refund your tire in the event that it is damaged, free of charge for 3 years (pro-rated after). Drive away with confidence and peace of mind. We’ve got you covered. See Tire Warranty terms for details.'
export const GENERIC_WARRANTY_NAME = 'Warranty'

export const THOUSANDTH_PART = 1000

export const DIGITS_REGEXP = /\d/g

export const BADGE_TYPE_MAP = {
  [TIRE_PROTECTION_PACKAGE]: 'tire-protection',
  [BIG_O_MILEAGE_WARRANTY]: 'manufactures-limited-warranty-badge',
  [MANUFACTURER_MILEAGE_WARRANTY]: 'manufactures-limited-warranty-badge'
}

export const NAME_SHORT_MAP = {
  [TIRE_PROTECTION_PACKAGE]: 'Tire Protection Package',
  [MANUFACTURER_MILEAGE_WARRANTY]: 'TreadLife Warranty',
  [BIG_O_MILEAGE_WARRANTY]: 'Warranty'
}

export const NAME_LONG_MAP = {
  [BIG_O_MILEAGE_WARRANTY]: 'Warranty'
}
